export const TableStyles = {
	// The parts of the component
	parts: ["td"],
	// The base styles for each part
	baseStyle: {},
	// The size styles for each part
	sizes: {},
	// The variant styles for each part
	variants: { simple: { td: { borderBottom: "0" } } },
	// The default `size` or `variant` values
	defaultProps: {},
};
